var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{attrs:{"options":_vm.outlets,"multiple":_vm.multiple,"value":_vm.value,"track-by":"id","label":"name","loading":_vm.onLoading('fetch-outlet'),"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"input":_vm.onInput}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c347a4a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/pug-deps-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/selector/multi-outlet-selector.vue
// module id = OnqG
// module chunks = 99